import React from "react";
import Modal from "react-modal";

import { IWebPageURL } from "../../../models/nominals";
import { focusElement } from "../../../utils/keyboardFocus";
import { useAppSelector } from "../../reducers";
import { ContactUsModalContent } from "./ContactUsModalContent";

interface IProps {
    isOpen: boolean;
    onClose: (
        event: React.MouseEvent<Element> | React.KeyboardEvent<Element>,
    ) => void;
    chatOfflineLink?: IWebPageURL;
}

export const ContactUsModal = (props: IProps): React.ReactNode => {
    const basket = useAppSelector((state) => state.checkout.data.basket);

    const modalStylePhone: Modal.Styles = {
        overlay: {
            zIndex: 200,
        },
        content: {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            margin: "auto",
            padding: "25px",
            overflowX: "hidden",
            overflowY: "auto",
            boxShadow: "none",
            border: "1px solid #c9ced1",
            borderRadius: "10px",
            backgroundColor: "#f7f7f7",
        },
    };

    return (
        <Modal
            // TODO(i18n): Use t tagged template for contentLabel: contentLabel={t`Contact Us`}
            contentLabel="Contact Us"
            aria={{ modal: true }}
            style={modalStylePhone}
            className="service-footer-modal-phone"
            isOpen={props.isOpen}
            onRequestClose={props.onClose}
            onAfterOpen={() => {
                focusElement(".service-footer-modal__close");
            }}
        >
            <ContactUsModalContent
                basket={basket}
                onCloseModalContact={props.onClose}
                chatOfflineLink={props.chatOfflineLink}
            />
        </Modal>
    );
};
